module.exports = __webpack_public_path__ + "static/top_sp-43cc45ed4249468e00c02de3b1cd671a.jpg";